import React from 'react';
import styles from './About.module.css';
import check from '../../assets/images/check.png';

const About = () => {
  return (
    <section className={styles.about}>
      <h2 className={styles.title}>О нас</h2>
      <p className={styles.description}>
        С 2015 года мы помогаем бизнесу преодолевать санкционные барьеры <br />
        и получать продукцию из Европы, США, Азии и других регионов.
      </p>

      <div className={styles.blocks}>
        <div className={styles.block}>
          <h3 className={styles.blockTitle}>Наш подход</h3>
          <p className={styles.blockText}>
            Мы работаем по прозрачной и гибкой схеме:
            анализируем рынок, находим надёжных
            поставщиков, организуем логистику, обеспечиваем
            таможенное оформление и сертификацию. Каждому
            клиенту назначается персональный менеджер,
            который сопровождает проект на всех этапах.
          </p>
          <p className={styles.blockText_bold}>
            Категории поставок
          </p>
          <p className={styles.blockText}>
            промышленное оборудование, техника, опасные
            грузы, негабарит, сыпучие и скоропортящиеся
            товары, биоматериалы, корма, добавки и многое
            другое.
          </p>
        </div>

        <div className={styles.block}>
          <h3 className={styles.blockTitle}>Почему нас выбирают</h3>
          <div className={styles.list}>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>9 лет на рынке международной логистики</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Собственные компании за рубежом для обхода ограничений</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Работаем с любыми типами товаров, включая негабарит и опасные грузы</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Индивидуальные маршруты и оптимизация сроков поставки</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Доставка "под ключ" до двери клиента</span>
            </div>
            <div className={styles.listItem}>
              <img src={check} alt="check" />
              <span>Обеспечиваем прозрачные и надёжные схемы поставок</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
